<svg width="390" height="844" viewBox="0 0 390 844" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="390" height="844" fill="#FF3ED4"/>
<mask id="mask0_236_36483" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="390" height="844">
<rect x="390" y="844" width="390" height="844" rx="4.87804" transform="rotate(-180 390 844)" fill="#480D93"/>
</mask>
<g mask="url(#mask0_236_36483)">
<mask id="mask1_236_36483" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="390" height="871">
<rect x="390" y="871" width="390" height="871" rx="4.87804" transform="rotate(-180 390 871)" fill="#480D93"/>
</mask>
<g mask="url(#mask1_236_36483)">
<mask id="mask2_236_36483" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="-104" y="-12" width="604" height="903">
<rect width="603.391" height="901.076" rx="4.87804" transform="matrix(1 0 0 -1 -103.969 890.02)" fill="#400C2B"/>
</mask>
<g mask="url(#mask2_236_36483)">
<path d="M74.9104 703.842C137.582 599.752 170.619 481.845 170.619 361.653L170.619 44.1875L224.881 44.1875L224.881 362.172C224.881 482.157 257.919 599.96 320.59 703.738L74.9104 703.738L74.9104 703.842Z" fill="#7B043D"/>
<path d="M197.727 449.441C234.168 539.715 328.976 604.227 440.002 604.227C582.364 604.227 693.391 466.79 698.196 337.456C707.707 78.4764 218.651 -321.16 197.727 -334.977C176.903 -321.16 -312.253 78.4764 -302.742 337.456C-297.937 466.79 -186.911 604.227 -44.5487 604.227C66.3775 604.227 161.285 539.715 197.727 449.441Z" fill="#7B043D"/>
</g>
</g>
</g>
</svg>
